import React from 'react'
import "./banner.css"
import FlexibleGrid from '../../../components/FlexibleGrid'
import Floater from '../../../components/Floaters/Floater'
function BannerFisrt() {
    return (
      <div className='lp-banner-1st'>
          <h1 className='main-text'>DSA SIMPLIFIED</h1>
          <p className='sub-text'>"<b>Master Data Structures & Algorithms</b> with <b>150</b> Curated Questions across various <b>Pattern</b>"</p>
          <p className='sub-text2'>Are you preparing for FANG (Facebook, Amazon, Netflix, Google) and other top tech interviews? You've come to the right place! </p>
          <p className='sub-text2'>The 150 essential DSA questions will equip you with the skills and confidence to ace any technical interview.</p>
      </div>
    )
}

function BannerSecond() {
    return (
      <div className='lp-banner-2nd'>
      <img className='bn-img' src='../../../../img/ladingPageBannerImg.webp' alt='Export Import illustration' />
      </div>
    )
}

function Banner() {
  return (
    <div className='lp-banner'>
        <Floater />
        <FlexibleGrid
        FirstBox={<BannerFisrt />}
        SecondBox={<BannerSecond />}
        FirstBoxWidth={"45%"}
        SecondBoxWidth={"55%"}
         />
    </div>
  )
}

export default Banner